import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Clean%20modern%20fashion%20lifestyle%20flatlay%20with%20sneakers%20hoodie%20accessories%20on%20light%20warm%20cream%20background%2C%20minimalist%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20elegant%20organic%20composition%2C%20European%20aesthetic%2C%20high%20detail%20product%20photography%20with%20gentle%20shadows%2C%20neutral%20warm%20tones%2C%20clean%20uncluttered%20styling%2C%20professional%20catalog%20look&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="Kakobuy Spreadsheet - produkty premium"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-20 px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-block px-3 py-1 rounded-full border border-white/30 text-white/90 text-xs font-medium mb-4 whitespace-nowrap">
            {t("hero.tag")}
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
            {t("hero.title")}
          </h1>

          <p className="mt-4 md:mt-6 text-white/80 text-sm md:text-base leading-relaxed max-w-xl">
            {t("hero.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mt-6 md:mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta.spreadsheet")}
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-white/50 text-white text-sm font-semibold hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta.products")}
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}